export const breakpointsConfig = {
  phoneBigger: 425,
  phone: 480,
  phablet: 768, // Tablet normally starts at 768, but naming it phablet for compatibility as there is already a tablet defined.
  tablet: 960,
  laptop: 1024,
  desktop: 1440,
  desktopLarge: 1920,
} as const
